export default __webpack_public_path__ + "static/media/crates_commander_3.7ea5a160.png";